import {Frontend} from "./frontend";

(function () {
    XonBoard.Buildings = {
        list: {

            selectors: {
                buildings_table: $('#buildings-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.buildings_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.buildings_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {
                            data: 'name',
                            name: 'buildings.name',
                            render: (name, type, item) => item.address ? `<div>${name}</div><div class="text-xs text-grey5">${$('<div>').text(item.address).html()}</div>` : name
                        },
                        {
                            data: 'latitude',
                            name: 'buildings.latitude',
                            searchable: false,
                            sortable: false,
                            render: (latitude, type, building) => XonBoard.Map.locationCell(latitude, building.longitude)
                        },
                        {data: 'site_name', name: 'buildings.site_id', searchable: false},
                        {data: 'building_type_name', name: 'buildings.building_type_id', searchable: false},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
